/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.23.2
 */

import { ICardContentParams } from '@nexign/scc-ui-kit/lib/components/RatePlanCard/types';

import { ICardTariffNewItem } from '../tariffsAndServicesProductTariffTypes';
import { TProductItem } from '../tariffsAndServicesProductTypes';

export const addRowParamsToProductList = (list: TProductItem[], columnsCount = 3): TProductItem[] => {
    const listWithRowParams: ICardTariffNewItem[] = [];

    const newItemList = list as ICardTariffNewItem[];

    for (let i = 0; i <= newItemList.length; i += columnsCount) {
        const sliceEnd = i + columnsCount;
        const tariffsRow = newItemList.slice(i, sliceEnd);

        const tariffsRowParams = tariffsRow.reduce(
            (rowParams, current) => {
                const benefitsCount = current.benefits?.value?.length;
                const internetUnlimitedCount = current.internetUnlimited?.value?.length;
                const internetLimitedCount = current.internetLimited?.value?.length;
                const includesCount = current.includedTariff?.value?.length;
                const roamingsCount = current.roamings?.value?.length;

                if (current.shortDescription) {
                    rowParams.withDescription = true;
                }

                if (current.mooreDetailsLink) {
                    rowParams.withDetails = true;
                }
                if (current.megaPowers?.value) {
                    rowParams.withMega = true;
                }
                if (current.ranges?.length) {
                    rowParams.withRanges = true;
                }
                if (current.kollektiv?.value) {
                    rowParams.withKollektiv = true;
                }

                const params: ICardContentParams = {
                    benefitsCount: calculateCount(benefitsCount, rowParams.benefitsCount),

                    internetUnlimitedCount: calculateCount(internetUnlimitedCount, rowParams.internetUnlimitedCount),

                    internetLimitedCount: calculateCount(internetLimitedCount, rowParams.internetLimitedCount),

                    includesCount: calculateCount(includesCount, rowParams.includesCount),

                    roamingsCount: calculateCount(roamingsCount, rowParams.roamingsCount),

                    withDescription: rowParams.withDescription,
                    withDetails: rowParams.withDetails,
                    withRanges: rowParams.withRanges,
                    withMega: rowParams.withMega,
                    withKollektiv: rowParams.withKollektiv,
                };

                return params;
            },
            {
                benefitsCount: 0,
                includesCount: 0,
                internetUnlimitedCount: 0,
                internetLimitedCount: 0,
                roamingsCount: 0,
                withDescription: false,
                withKollektiv: false,
                withDetails: false,
                withRanges: false,
                withMega: false,
            } as ICardContentParams,
        );

        listWithRowParams.push(...tariffsRow.map((el) => ({ ...el, rowParams: tariffsRowParams })));
    }

    return listWithRowParams;
};

function calculateCount(fieldCount?: number, rowCount?: number) {
    return !!fieldCount && fieldCount > (rowCount || 0) ? fieldCount : rowCount;
}
